import React, { useState, useRef, useEffect } from 'react';
import './LowerUpperMode.scss';
import FormTemperatureBox from './FormTemperatureBox';
import icon_info from '../../assets/icon_info.svg';

const LowerUpperMode = ({
  handleChange,
  index,
  selectedLower,
  selectedUpper,
  selectedBlockCooling,
  selectedBlockHeating,
}) => {
  let convertedMode;

  if (selectedBlockCooling === false && selectedBlockHeating === false) {
    convertedMode = 'auto';
  } else if (selectedBlockCooling === true && selectedBlockHeating === true) {
    convertedMode = 'fan';
  } else if (selectedBlockCooling === true && selectedBlockHeating === false) {
    convertedMode = 'heat';
  } else if (selectedBlockCooling === false && selectedBlockHeating === true) {
    convertedMode = 'cool';
  }

  const [showInfo, setShowInfo] = useState(false);
  const infoRef = useRef(null);

  useEffect(() => {
    window.addEventListener('click', hideInfo);

    return () => {
      window.removeEventListener('click', hideInfo);
    };
  }, [showInfo]);

  const hideInfo = (e) => {
    if (showInfo) {
      if (e.target !== infoRef.current) {
        setShowInfo(false);
      }
    }
  };

  return (
    <div className="mode-settings lowerUpperMode-container">
      <div className="bounds-temperatures">
        <FormTemperatureBox
          label="Lower Bound"
          name="lower_bound"
          defaultValue={selectedLower ? selectedLower : 68}
          updateField={(e) => handleChange(index, 'lowerBound', e)}
        />

        <FormTemperatureBox
          label="Upper Bound"
          name="upper_bound"
          defaultValue={selectedUpper ? selectedUpper : 75}
          updateField={(e) => handleChange(index, 'upperBound', e)}
        />
      </div>

      <div className="mode-container">
        <label>
          Mode{' '}
          <img
            src={icon_info}
            width="12"
            height="12"
            onClick={() => setShowInfo(!showInfo)}
            ref={infoRef}
          ></img>
        </label>
        <select
          onChange={(e) => handleChange(index, e.target.value, e.target.value)}
          defaultValue={convertedMode ? convertedMode : 'auto'}
        >
          <option value="auto">Auto</option>
          <option value="heat">Heat Only</option>
          <option value="cool">Cool Only</option>
          <option value="fan">Fan Only</option>
        </select>
      </div>

      {showInfo && (
        <div className="mode-block">
          <div className="main-content">
            <div className="mode-content">
              <p>
                <span>Auto:</span> The Elexity system can heat or cool as needed in order to most
                effectively manage both comfort and cost.
              </p>

              <p>
                <span>Cool Only:</span> The Elexity system will not call for heating during this
                period.<span>*</span>
              </p>

              <p>
                <span>Heat Only:</span> The Elexity system will not call for cooling during this
                period.<span>*</span>
              </p>

              <p>
                <span>Fan Only:</span> The Elexity system will not call for cooling or heating
                during this period.<span>*</span>
              </p>
            </div>

            <div className="note-content">
              *Note that, under some circumstances, the Cool / Heat / Fan Only flag will be
              overruled:
              <ul>
                <li>
                  Buildings will not be allowed to cool below 40F / 5C, in order to prevent freezing
                  damage.
                </li>
                <li>
                  If the following time period allows for heating or cooling, the Elexity system may
                  turn on heating or cooling early in order to “ramp” the temperature to the desired
                  setpoint.
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LowerUpperMode;
